/**
 * ProductStock Component
 */
//jshint ignore:start
(function () {

    'use strict';

    /**
     * Size Guide
     */
    var ItxProductStockCmp = {
        bindings: {
            reference: '<',
            detail: '<',
            color: '<',
            closeDialog: '&'
        },
        controller: ItxProductStockCmpCtrl,
        controllerAs: 'productStockCtrl',
        templateUrl: 'ItxProductStockCmp.html'
    };

    ItxProductStockCmpCtrl.$inject = [
        'ItxUtilsFct', 
        'ngDialog',
        'ItxScreenSizeSvc'
    ];

    function ItxProductStockCmpCtrl(
        ItxUtilsFct, 
        ngDialog,
        ItxScreenSizeSvc
    ) {
        var _this = this;
        _this.active = 'selectSize';
        _this.sizes = [];
        _this.productPartnumber = _this.reference.split('-')[0];
        
        //Tratamiento de hermanados
        var groupedSizes = _.groupBy(_this.color.sizes, 'name');
        _.each(groupedSizes, function(group) {
            var validSku = null;
            var mainSku = null;
            _.each(group, function(size) {
                //Si el "principal" (mismo aprntumber que el padre) tiene stock se coge siempre
                if (size.partnumber.indexOf(_this.productPartnumber) > -1) {
                    mainSku = size;
                    if (size.visibilityValue.toLowerCase() === joyr.constants.visibility.SHOW_VISIBILITY) {
                        validSku = size;
                        // return false;
                    }
                }
                //Si el "hermanada" (distinto partNumber) tiene stock, se coge siempre que no hayamos cogido el "principal"
                if ((size.partnumber.indexOf(_this.productPartnumber) === -1) && (size.visibilityValue.toLowerCase() === joyr.constants.visibility.SHOW_VISIBILITY) && (!validSku)) {
                    validSku = size;
                }

                //Si ninguno tiene stock, se coge el "princiapl"
                if (!validSku) {
                    validSku = mainSku;
                }
                if (validSku) {
                    _this.sizes.push(validSku);
                }
            });
        });

        _this.getProductImage = function () {
            return ItxUtilsFct.getImageProductUrls(_this.detail, _this.color.id, 'productPage', 'main', 'product')[0];
        };

        _this.noSizesSelected = function () {
            return !(_.find(_this.sizes, function (size) {
                return size.selected;
            }));
        };

        _this.getSelectedSizes = function () {
            return _.filter(_this.sizes, function (size) {
                return size.selected;
            });
        }

        _this.getPartNumber = function () {
            return _.sample(_this.sizes).partnumber;
        }

        _this.onSelectStore = function () {
            _this.active = 'sizeForm';
        }

        _this.searchStores = function () {
            if (!_this.noSizesSelected()) {
                ngDialog.open({
                        template: '<itx-store-locator-header close-dialog="closeThisDialog()"></itx-store-locator-header> <itx-store-locator search-type="ngDialogData.searchType" ' +
                           'is-popup="true" ' +
                           'selected-sizes="ngDialogData.selectedSizes" ' +
                           (joyr.booking.utils.isBookingAllowed() ? 'on-select-store="ngDialogData.onSelectStore(store)" ' : '') +
                           'action="ngDialogData.action"' +
                           'close-dialog="closeThisDialog()">' +
                                '</itx-store-locator>',
                        plain: true,
                        className: 'ngdialog-theme-plain ngdialog-store-map',
                        showClose: ItxScreenSizeSvc.is('xs,sm'),
                        bindToController: true,
                        data: {searchType: 'store',
                               selectedSizes: _this.getSelectedSizes(),
                               onSelectStore: _this.onSelectStore,
                               action: false
                              }
                    });
            }
        }
    }

    /** Public */
    angular.module('itxApp.catalog')
        .component('itxProductStock', ItxProductStockCmp);

})();
